<template>
    <div class="dna-attrs-wrap">
        <el-row>
            <el-col :span="span">
                <div
                    v-if="mode === 'edit'"
                    class="custom-fixed-attr-wrap"
                >
                    <slot name="brandIdSlot">
                        <!-- todo 优化封装一层 -->
                        <el-form-item
                            v-if="brandAttrData"
                            label="品牌"
                            class="is-required"
                        >
                            <!-- 使用推荐值时，根据id查询品牌来正确回显label => handleWatch属性设为true，调用相关接口 -->
                            <new-brand-select
                                :value="sv2v(brandAttrData.selectedValues)"
                                handle-watch
                                use-scroll
                                :disabled="fixedAttrProps.brandId.disabled || fixedAttrProps.common.disabled"
                                @change="(item) => { onFixedAttrChange(item.brandId, { id: item.brandId, value: item.brandName }, brandAttrData) }"
                            />
                            <FocusTag v-if="focusAttrData.brandId" />
                            <div
                                style="color: #95989E; fontSize:12px"
                            >
                                未找到对应品牌？
                                <xx-link
                                    path="https://tt.sankuai.com/maicaishiyebu/create?cid=569&tid=5297&iid=24821"
                                >
                                    前往申请
                                </xx-link>
                                ,若无法操作申请，请联系采购，让采购申请
                            </div>
                            <div v-if="innerRecommendValueObj.brandName">
                                <mc-tag
                                    theme="green"
                                    type="pure"
                                >
                                    推荐
                                </mc-tag>
                                {{ innerRecommendValueObj.brandName }}
                                <mc-button
                                    v-if="!(fixedAttrProps.brandId.disabled || fixedAttrProps.common.disabled || spuDisabled)"
                                    type="text"
                                    size="small"
                                    @click="() => { onFixedAttrChange(innerRecommendValueObj.brandId, { id: innerRecommendValueObj.brandId, value: innerRecommendValueObj.brandName }, brandAttrData) }"
                                >
                                    使用推荐
                                </mc-button>
                            </div>
                        </el-form-item>
                    </slot>
                    <slot name="importFlagSlot">
                        <el-form-item
                            v-if="importAttrData"
                            label="是否进口"
                            class="is-required"
                        >
                            <xx-select
                                :value="sv2v(importAttrData.selectedValues)"
                                :list="importAttrData.selectValues"
                                filterable
                                use-scroll
                                label-key="value"
                                value-key="id"
                                :clearable="false"
                                :disabled="fixedAttrProps.importFlag.disabled || fixedAttrProps.common.disabled"
                                @change="(val, item) => { onFixedAttrChange(val, item, importAttrData) }"
                            />
                            <FocusTag v-if="focusAttrData.importFlag" />
                            <div v-if="innerRecommendValueObj.importFlagName">
                                <mc-tag
                                    theme="green"
                                    type="pure"
                                >
                                    推荐
                                </mc-tag>
                                {{ innerRecommendValueObj.importFlagName }}
                                <mc-button
                                    v-if="!(fixedAttrProps.importFlag.disabled || fixedAttrProps.common.disabled)"
                                    type="text"
                                    size="small"
                                    @click="() => { onFixedAttrChange(innerRecommendValueObj.importFlag, { value: innerRecommendValueObj.importFlagName, id: innerRecommendValueObj.importFlag }, importAttrData) }"
                                >
                                    使用推荐
                                </mc-button>
                            </div>
                        </el-form-item>
                    </slot>
                    <slot name="storageTemperatureLevelSlot">
                        <el-form-item
                            v-if="storageTemperatureLevelAttrData"
                            label="储存条件"
                            class="is-required"
                        >
                            <xx-select
                                :value="sv2v(storageTemperatureLevelAttrData.selectedValues)"
                                :list="storageTemperatureLevelAttrData.selectValues"
                                filterable
                                use-scroll
                                label-key="value"
                                value-key="id"
                                :clearable="false"
                                :disabled="fixedAttrProps.storageTemperatureLevel.disabled || fixedAttrProps.common.disabled"
                                @change="(val, item) => { onFixedAttrChange(val, item, storageTemperatureLevelAttrData) }"
                            />
                            <FocusTag v-if="focusAttrData.storageTemperatureLevel" />
                            <div v-if="innerRecommendValueObj.storageTemperatureLevelName">
                                <mc-tag
                                    theme="green"
                                    type="pure"
                                >
                                    推荐
                                </mc-tag>
                                {{ innerRecommendValueObj.storageTemperatureLevelName }}
                                <mc-button
                                    v-if="!(fixedAttrProps.storageTemperatureLevel.disabled || fixedAttrProps.common.disabled)"
                                    type="text"
                                    size="small"
                                    @click="() => { onFixedAttrChange(innerRecommendValueObj.storageTemperatureLevel, { value: innerRecommendValueObj.storageTemperatureLevelName, id: innerRecommendValueObj.storageTemperatureLevel }, storageTemperatureLevelAttrData) }"
                                >
                                    使用推荐
                                </mc-button>
                            </div>
                        </el-form-item>
                        <el-form-item
                            v-if="storageTemperatureLevelAttrData && sv2v(storageTemperatureLevelAttrData.selectedValues) === 5"
                            label="最佳储存温段"
                        >
                            <el-select
                                :value="storageTemperatureLevelRemark"
                                @change="(val) => onExpandChange(val, 'storageTemperatureLevelRemark')"
                            >
                                <el-option
                                    v-for="item in perfectOptions"
                                    :key="item.value"
                                    :value="item.value"
                                    :label="item.label"
                                />
                            </el-select>
                        </el-form-item>
                    </slot>
                </div>
                <div
                    v-else
                    class="custom-fixed-attr-wrap"
                >
                    <slot
                        name="brandIdDetailSlot"
                        :data="brandAttrData"
                    ></slot>
                    <slot
                        name="storageTemperatureLevelDetailSlot"
                        :data="storageTemperatureLevelAttrData"
                    >
                    </slot>
                    <slot
                        name="importFlagSlot"
                        :data="importAttrData"
                    ></slot>
                </div>
                <!-- DNA属性中的扩展属性 -->
                <!-- {attrId:64,id:40988} 资质认证,默认值:无资质认证 -->
                <ExtAttrPanel
                    :extattrs="extAttrList"
                    :recommend-attr-list="innerRecommendValueObj.skuExtAttrList || []"
                    :mode="mode"
                    empty-text="--"
                    ignore-valid
                    :can-clear="false"
                    :hide-attrs-ids="customFixedAttrIds"
                    :default-disabled="defaultDisabled"
                    :default-single-disabled="defaultSingleDisabled"
                    :focused-marking-list="focusAttrData.extAttrList || []"
                    @skuExtAttrChange="changeDnaAttrs"
                >
                    <!-- 提示信息 -->
                    <template
                        v-if="footerShowTip.includes(attr.attrId)"
                        slot="tip"
                        slot-scope="{attr}"
                    >
                        <div class="tip">
                            {{ attrTipConfig[attr.attrId].message }}
                        </div>
                    </template>
                </ExtAttrPanel>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import emitter from 'utils/emitter';
import ExtAttrPanel from '../extAttrPanel';
import store from './store';
import NewBrandSelect from '../NewBrandSelect';
import FocusTag from '../../pages/product/components/FocusTag';

const defaultFixedAttrProps = {
    brandId: {
        disabled: false,
    },
    importFlag: {
        disbaled: false,
    },
    storageTemperatureLevel: {
        disabled: false,
    },
    common: {
        disabled: false,
    },
};

export default {
    name: 'DnaAttrsWrap',
    componentName: 'validate-form',
    components: {
        ExtAttrPanel,
        NewBrandSelect,
        FocusTag,
    },
    mixins: [emitter],
    props: {
        // 后台类目id
        bgCategoryId: {
            type: [Number, String],
            required: true,
        },
        // 已选择的属性列表
        selectedAttrList: {
            type: Array,
            default: () => [],
        },
        // 状态 编辑还是详情
        mode: {
            type: String,
            default: 'detail',
        },
        // 是否需要过滤掉空值的扩展属性
        isFilterBlankExt: {
            type: Boolean,
            default: false,
        },
        span: {
            type: Number,
            default: 24,
        },
        defaultDisabled: {
            type: Boolean,
            default: false,
        },
        // 传入需要自定义的固定属性name集合，此时dna组件中不会渲染对应的固定属性
        needCustomFixedAttrNameList: {
            type: Array,
            default: () => ([]),
        },
        customFixedAttrProps: {
            type: Object,
            default: () => defaultFixedAttrProps,
        },
        storageTemperatureLevelRemark: {
            type: [String, Number],
            default: '',
        },
        // 推荐的属性值
        recommendValueObj: {
            type: Object,
            default: () => ({}),
        },
        // c端展示重点属性
        focusAttrData: {
            type: Object,
            default: () => ({}),
        },
        defaultSingleDisabled: {
            type: Array,
            default: () => ([]),
        },
        defaultAttrsId: {
            type: Array,
            default: () => ([]),
        },
        // 属性提示信息配置
        attrTipConfig: {
            type: Object,
            default: () => ({}),
        },
        // 底部需要展示的tip
        footerShowTip: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
            extAttrList: [],
            innerSelectedAttrList: this.selectedAttrList,
            innerRecommendValueObj: this.recommendValueObj,
            errList: [],

            perfectOptions: [
                {
                    label: '建议冷藏',
                    value: 1,
                },
            ],
            attrDisabledMap: {
                QUALIFICATION_CERTIFICATION: 64, // 资质认证id
            },
        };
    },
    computed: {
        // 自定义固定属性
        customFixedAttr() {
            const attrs = [];
            const fixedAttrs = this.extAttrList.filter((attr) => attr.attrType === 2);
            this.needCustomFixedAttrNameList.forEach((name) => {
                const target = fixedAttrs.find((attr) => attr.attrAlias === name);
                if (target) {
                    attrs.push(target);
                }
            });
            return attrs;
        },
        customFixedAttrIds() {
            return this.customFixedAttr.map((attr) => attr.attrId);
        },
        brandAttrData() {
            return this.getFixedAttrData('brandId');
        },
        importAttrData() {
            return this.getFixedAttrData('importFlag');
        },
        storageTemperatureLevelAttrData() {
            return this.getFixedAttrData('storageTemperatureLevel');
        },
        fixedAttrProps() {
            return Object.assign(defaultFixedAttrProps, this.customFixedAttrProps);
        },
    },
    watch: {
        selectedAttrList(newVal) {
            this.innerSelectedAttrList = newVal;
        },
        recommendValueObj: {
            handler(val) {
                this.innerRecommendValueObj = val;
            },
            deep: true,
        },
        bgCategoryId(id) {
            if (id) {
                this.init(true);
            } else {
                this.resetData();
            }
        },
    },
    created() {
        if (this.bgCategoryId) {
            this.init(true);
        }
        this.$on('validate-message', this.onValid);
    },
    beforeDestroy() {
        this.resetData();
    },
    methods: {
        async fetchAllExtAttr(bgCategoryId) {
            const res = await this.$service.getDnaAttrsByBgCategoryId({
                bgCategoryId,
            }).catch(() => 'error');
            if (res === 'error') return [];

            // 以下的固定属性不在dna属性模块展示，还在原来位置展示，要过滤
            const isNotShowFixedAttr = ['importFlag', 'areas', 'bgCategory', 'skuName', 'storageTemperatureLevel'];
            return res.dnaAttrAndSelectableValues.filter((item) => !isNotShowFixedAttr.includes(item.attrAlias)).map((item) => {
                let selectedValues = [];

                // 根据defaultAttrsId填充默认值
                const targetAttr = (this.defaultAttrsId || []).find((defaultItems) => defaultItems.attrId === item.attrId);
                if (targetAttr) {
                    if (targetAttr.id) {
                        // 查找指定的值
                        const targetValue = item.selectValues.find((items) => items.id === targetAttr.id);
                        if (targetValue) {
                            selectedValues = [{
                                id: targetAttr.id,
                                value: targetValue.value,
                            }];
                        }
                    } else {
                        // 如果defaultAttrsId中没有id，则使用value和unit填充默认值
                        selectedValues = [{
                            id: 0,
                            value: targetAttr.value || '',
                            unit: targetAttr.unit || '',
                        }];
                    }
                }

                return {
                    ...item,
                    selectedValues,
                    requireFlag: true, // 默认都是必填
                };
            });
        },
        async init(isFillSelected = false) {
            const {
                bgCategoryId, innerSelectedAttrList,
            } = this;
            const dnaAttrs = await this.fetchAllExtAttr(bgCategoryId);
            // 固定属性
            const fixedAttrAliasNames = [];
            // 扩展属性
            const extAttrIds = [];
            dnaAttrs.forEach((attr) => {
                // 添加资质认证默认信息
                if (
                    attr.attrId === this.attrDisabledMap.QUALIFICATION_CERTIFICATION
                    && !attr.selectedValues.length
                ) {
                    const selectedValues = [{
                        id: 40988,
                        value: '无资质认证',

                    }];
                    attr.selectedValues = selectedValues;
                }
                if (attr.attrType === 1) extAttrIds.push(attr.attrId);
                if (attr.attrType === 2) fixedAttrAliasNames.push(attr.attrAlias);
            });
            store.fixedAttrs = fixedAttrAliasNames;
            store.extAttrs = extAttrIds;

            // 回显扩展属性的值，从innerSelectedAttrList中提取selectedValues，合并到filterExtAttr中
            // 页面初始化（isFillSelected为true）时回显，切换类目则清空回显数据
            if (innerSelectedAttrList && innerSelectedAttrList.length && isFillSelected) {
                innerSelectedAttrList.forEach((skuAttr) => {
                    if (skuAttr.selectedValues && skuAttr.selectedValues.length) {
                        const targetAttr = dnaAttrs.find((item) => +item.attrId === +skuAttr.attrId);
                        if (targetAttr) {
                            targetAttr.selectedValues = skuAttr.selectedValues;
                        }
                    }
                });
            }

            this.extAttrList = dnaAttrs;
            this.$emit('attrs-loaded', dnaAttrs);
            this.$emit('selectedDnaAttrList', dnaAttrs);
        },
        resetData() {
            this.extAttrList = [];
            this.innerSelectedAttrList = [];
            this.$emit('selectedDnaAttrList', []);
            this.$emit('attrs-loaded', []);
            store.fixedAttrs = [];
            store.extAttrs = [];
        },
        changeDnaAttrs(data) {
            const index = this.extAttrList.findIndex((v) => `${v.attrId}` === `${data.attrId}`);
            if (index > -1) {
                this.$set(this.extAttrList[index], 'selectedValues', data.selectedValues);
            }
            // 仅返回某一个表单项的值
            this.$emit('extAttrChange', data);
            // 返回全部已选择的extList
            if (this.isFilterBlankExt) {
                this.$emit('selectedDnaAttrList', this.extAttrList.filter((attr) => attr.selectedValues && attr.selectedValues.length).map((item) => ({ attrId: item.attrId, selectedValues: item.selectedValues, attrType: item.attrType })));
            } else {
                this.$emit('selectedDnaAttrList', this.extAttrList.map((item) => ({ attrId: item.attrId, selectedValues: item.selectedValues, attrType: item.attrType })));
            }
        },
        validate() {
            this.errList = [];
            // 自定义固定属性校验
            this.validCustomFixedAttrs();
            this.broadcast('validate-input', 'validate');
            if (this.errList.length) {
                this.$notify.error({
                    title: '以下信息有误: ',
                    message: this.$createElement('div', this.errList.map((item) => this.$createElement('p', item))),
                });
                return false;
            }
            return true;
        },
        onValid(msg) {
            if (msg && !this.errList.includes(msg)) {
                this.errList.push(msg);
            }
        },
        sv2v(sv) {
            return sv[0] ? sv[0].id : '';
        },
        getFixedAttrData(attrName) {
            const target = this.extAttrList.find((attr) => attr.attrAlias === attrName);
            return target;
        },
        onFixedAttrChange(val, item, attrData) {
            const value = (val || val === 0) ? val : '';
            // todo valid
            this.changeDnaAttrs({
                attrId: attrData.attrId,
                selectedValues: (val || val === 0) ? [item] : [],
            });
            this.$emit('changeFixedAttrData', {
                attrName: attrData.attrAlias,
                attrValue: value,
                attrItem: item,
                attrData,
            });
        },
        validCustomFixedAttrs() {
            if (!this.customFixedAttr || !this.customFixedAttr.length) return;
            this.customFixedAttr.forEach((attr) => {
                const value = this.sv2v(attr.selectedValues);
                if (value === '' || value.length === 0) {
                    this.onValid(`${attr.attrName}属性为必填项`);
                }
            });
        },

        onExpandChange(val, key) {
            this.$emit('onExpandChange', { val, key });
        },
    },
};
</script>

<style lang="scss" scoped>
.tip{
    color: #999;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 4px;
}
</style>
